module.exports = __webpack_public_path__ + "img/icon_support_08.aeed6c0e.png";